import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

import { useItineraryData } from '@/clientState/hooks/useItineraryData';
import {
  CheckoutPageContentContainer,
  CheckoutPageMainContent,
} from '@/components/CheckoutPagesLayout';
import { FlightSummaryContainer } from '@/components/FlightsPaymentPage/components';
import { MapItinerary } from '@/components/FlightSummary/MapItinerary';
import SkeletonMapItinerary from '@/components/FlightSummary/MapItinerary/components/SkeletonMapItinerary';
import NoResults from '@/components/FlightSummaryMeta/components/NoResults';
import { useShoppingSummaryItinerary } from '@/queries/useShoppingSummaryItinerary';
import Footer from './components/FlightSummaryMetaFooter';
import FlightSummaryMetaHeader from './components/FlightSummaryMetaHeader';
import PrimeDaysBanner from '@/components/FlightSummaryMeta/components/PrimeDaysBanner';
import { PrimeDaysSkeleton } from './components/PrimeDaysBanner/PrimeDaysBanner';
import type { FlightSummaryMetaProps } from './types';

const FlightSummaryMeta: FC<FlightSummaryMetaProps> = ({
  primeEqualProminenceMobile,
}) => {
  const { data, loading } = useShoppingSummaryItinerary();
  const { destinationName } = useItineraryData(data?.products);
  const hasProducts = data && data.products.length > 0;

  return (
    <>
      {!loading ? <PrimeDaysBanner /> : <PrimeDaysSkeleton />}
      <CheckoutPageContentContainer>
        <CheckoutPageMainContent noPadding={true}>
          <FlightSummaryContainer>
            {loading ? (
              <SkeletonMapItinerary isMetaSummary={true} />
            ) : (
              <Box mb="2x_big">
                {hasProducts ? (
                  <>
                    <FlightSummaryMetaHeader
                      destinationName={destinationName}
                    />
                    <MapItinerary data={data.products} isMetaSummary={true} />
                  </>
                ) : (
                  <NoResults />
                )}
              </Box>
            )}
            <Footer primeEqualProminenceMobile={primeEqualProminenceMobile} />
          </FlightSummaryContainer>
        </CheckoutPageMainContent>
      </CheckoutPageContentContainer>
    </>
  );
};

export default FlightSummaryMeta;
